/**
 * The one sentence an operator reads after an Apply.
 * For Media Devoted | Created By Ciro Autiero
 *
 * A partial write is never summarised as a count alone: "9 of 10" tells the
 * reader something is wrong without telling them what, so the sentence here is
 * only ever the headline above a list that NAMES every element left out.
 */

import type { FlowOptimizerApplyReport } from '@trafficpulse/shared';

export function isPartialApply(
  report: FlowOptimizerApplyReport | undefined,
): report is FlowOptimizerApplyReport {
  return (report?.skipped ?? 0) > 0;
}

const noun = (n: number, layer: string) =>
  `${n} ${n === 1 ? layer.replace(/s$/, '') : layer}`;

/** "9 of 10 landers got their new weight." */
export function applyHeadline(report: FlowOptimizerApplyReport): string {
  const total = report.ok + report.skipped;
  const layer = report.rows[0]?.layer ?? 'landers';
  if (report.ok === 0) {
    return `No weights were written — ${noun(total, layer)} ${total === 1 ? 'was' : 'were'} skipped.`;
  }
  return `${report.ok} of ${noun(total, layer)} got their new weight. Here's the rest:`;
}
